/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

const StyledAlert = styled(({ ...props }) => (
  <Typography {...props} variant="body1" select>
    {props.msg}
  </Typography>
))`
  ${({ theme }) => `
  background: #FFFFFF;
  border: 2px solid #00C2FF;
  box-sizing: border-box;
  padding: ${theme.spacing(2)}px ${theme.spacing(5.75)}px ${theme.spacing(
    2
  )}px ${theme.spacing(5.75)}px ;
  `}
`;
export default StyledAlert;
